import Vue from "vue";
import VueRouter from "vue-router";

import SiteLayout from "@/views/layout/SiteLayout";
// Site Views ==> Lazy lodading components
const HomeView = () => import("@/views/site/Home/HomeView");
const AboutView = () => import("@/views/site/AboutView");
const Gallery = () => import("@/views/site/gallery/GalleryView");
const IeltsView = () => import("@/views/site/courses/IeltsView");
const KidsEnglish = () => import("@/views/site/courses/KidsEnglish");
const SpokenEnglish = () => import("@/views/site/courses/SpokenEnglish");
const InterviewEnglish = () => import("@/views/site/courses/InterviewEnglish");
const ContactView = () => import("@/views/site/ContactView");
const Redirect = () => import("@/views/site/Home/HomeView");
const PrivacyPolicy = () => import("@/views/site/PrivacyPolicy");
const AdmissionsView = () => import("@/views/site/AdmissionsView");
const Schools = () => import("@/views/site/services/Schools");
const Colleges = () => import("@/views/site/services/Colleges");
const Corporates = () => import("@/views/site/services/Corporates");
const Careers = () => import("@/views/site/CareersView");
const PteView = () => import("@/views/site/courses/PteView");

Vue.use(VueRouter);

var routes;
var siteRoutesArray = [
  {
    path: "/",
    component: HomeView,
    name: "Home",
    meta: {
      title:
        "Accenta Education – IELTS, UKVI & Spoken English Coaching, Chalakudy",
    },
  },
  {
    path: "about",
    component: AboutView,
    name: "About",
    meta: { title: "About Us & Our Team | Accenta Education" },
  },
  {
    path: "gallery",
    component: Gallery,
    name: "Gallery",
    meta: { title: "Gallery | Accenta Education" },
  },
  {
    path: "ielts",
    component: IeltsView,
    name: "Ielts",
    meta: {
      title: "IELTS Programs – Crash, Extensive & Online | Accenta Education",
    },
  },
  {
    path: "pte",
    component: PteView,
    name: "pte",
    meta: { title: "PTE Programs – Extensive & Online | Accenta Education" },
  },
  {
    path: "kids-english",
    component: KidsEnglish,
    name: "KidsEnglish",
    meta: { title: "Kids English Classes – Online & Offline | Accenta Education" },
  },
  {
    path: "spoken-english",
    component: SpokenEnglish,
    name: "SpokenEnglish",
    meta: {
      title: "Spoken English Classes – Online & Offline | Accenta Education",
    },
  },
  {
    path: "interview-english",
    component: InterviewEnglish,
    name: "InterviewEnglish",
    meta: {
      title: "Interview English Training | Accenta Education",
    },
  },
  {
    path: "contact",
    component: ContactView,
    name: "Contact",
    meta: { title: "Contact Us – Chalakudy | Accenta Education" },
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicy,
    name: "Privacy",
    meta: { title: "Privacy Policy | Accenta Education" },
  },
  {
    path: "admissions",
    component: AdmissionsView,
    name: "Admissions",
    meta: {
      title: "MBBS, Nursing & Abroad Admissions | Accenta Education",
    },
  },
  {
    path: "schools",
    component: Schools,
    name: "Schools",
    meta: {
      title: "School Programs – Communicative English | Accenta Education",
    },
  },
  {
    path: "colleges",
    component: Colleges,
    name: "Colleges",
    meta: {
      title: "College Programs – Smart Teacher & More | Accenta Education",
    },
  },
  {
    path: "corporates",
    component: Corporates,
    name: "Corporates",
    meta: {
      title:
        "Corporate Training – Business Communication | Accenta Education",
    },
  },
  {
    path: "careers",
    component: Careers,
    name: "Careers",
    meta: { title: "Careers – Join Us | Accenta Education" },
  },

  {
    path: "*",
    component: Redirect,
    meta: {
      title:
        "Accenta Education – IELTS, UKVI & Spoken English Coaching, Chalakudy",
    },
  },
];
routes = [
  {
    path: "/",
    component: SiteLayout,
    children: siteRoutesArray,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.PUBLIC_PATH,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
